import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataBarChartComponent, DataChangeIndicatorComponent, DataTileComponent, DataTileListComponent, DataTitleComponent, DataValueRowCardComponent } from './components';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DataDeviceOverTimeChartComponent } from './components/data-device-over-time-chart/data-device-over-time-chart.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SegmentedDataTileComponent } from './components/segmented-data-tile/segmented-data-tile.component';
import { FormsModule } from '@angular/forms';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { TimeAgoPipe } from 'time-ago-pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { TimeAgoExtendsPipe } from '../../../tools/pipes/time-ago.pipe';

@NgModule({
  declarations: [
    DataTileComponent,
    DataTileListComponent,
    DataChangeIndicatorComponent,
    DataTitleComponent,
    DataValueRowCardComponent,
    DataBarChartComponent,
    DataDeviceOverTimeChartComponent,
    SegmentedDataTileComponent,
    SkeletonLoaderComponent,
    TimeAgoExtendsPipe,
  ],
  imports: [CommonModule, NgApexchartsModule, NgxPaginationModule, FormsModule, MaterialModule, NgxSkeletonLoaderModule, MatRowComponent, MatColComponent],
  exports: [
    DataTileComponent,
    DataTileListComponent,
    DataChangeIndicatorComponent,
    DataTitleComponent,
    DataValueRowCardComponent,
    DataBarChartComponent,
    DataDeviceOverTimeChartComponent,
    SegmentedDataTileComponent,
    SkeletonLoaderComponent,
    TimeAgoExtendsPipe,
  ],
  providers: [TimeAgoExtendsPipe],
})
export class DataModule {}
